module.exports = __webpack_public_path__ + "img/ss-9.f1098645.png";